"use strict";

exports.__esModule = true;
exports["default"] = Select;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Select(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256.757 510.348a1.204 1.204 0 0 1-1.516 0L44.273 328.636c-.417-.358-.308-.652.242-.652h422.968c.55 0 .659.294.242.652L256.757 510.348zM255.226 1.66a1.172 1.172 0 0 1 1.502 0l211.028 185.528c.413.363.301.66-.249.66H44.493c-.55 0-.662-.297-.249-.66L255.226 1.66z"
  }));
}